import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Contact {
  constructor() {
    const tablet = window.matchMedia("(max-width: 1040px)");
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.scroll = document.querySelectorAll('a.scroll');
      cache.faq = document.querySelector('.faq');
      cache.drop = document.querySelectorAll('.dropdown_wrap .question');
    };

    let registerEvents = () => {
      for (var i = 0; i < cache.scroll.length; i++) {
        cache.scroll[i].addEventListener("click", scrollTo);
      }
      for (var i = 0; i < cache.drop.length; i++) {
        cache.drop[i].addEventListener("click", drop);
      }
    };


    let scrollTo = function(e) {
      document.querySelector('body').classList.add('scroll');
      e.preventDefault();
      var target = document.querySelector(this.getAttribute("href"));
      anime({
        targets: globalVar.scrollElement,
        scrollTop: (globalVar.scrollElement.scrollTop+target.getBoundingClientRect().top-150),
        duration: 400,
        easing: 'easeOutQuad',
        complete: function () {
          document.querySelector('body').classList.remove('scroll');
        }
      });
    }

    let drop = function() {
      let parent = this.parentNode;
      if(cache.faq.querySelector('.dropdown_wrap.active') && !parent.classList.contains('active')) {
        let active = cache.faq.querySelector('.dropdown_wrap.active');
        active.classList.remove('active');
        anime({
          targets: active.querySelector('.question svg'),
          rotate: 180,
          duration: 400,
          easing: 'easeOutQuad',
        });
        anime({
          targets: active.querySelector('.answer'),
          height: 0,
          duration: 400,
          easing: 'easeOutQuad',
          complete: function() {
            active.querySelector('.answer').style.display = "none";
          }
        });
      }

      if(!parent.classList.contains('active')) {
        parent.classList.add('active');
        parent.querySelector('.answer').style.display = "block";
        parent.querySelector('.answer').style.height = "auto";
        let height = parent.querySelector('.answer').offsetHeight;
        parent.querySelector('.answer').style.height = 0;

        anime({
          targets: parent.querySelector('.question svg'),
          rotate: 0,
          duration: 400,
          easing: 'easeOutQuad',
        });
        anime({
          targets: parent.querySelector('.answer'),
          height: height,
          duration: 400,
          easing: 'easeOutQuad'
        });
      }

    }

    initFunc();
  };
}
export { Contact }
